import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {FlashBanner} from 'shells/flash-banner/flash-banner';
// @ts-expect-error - imported from .js/.jsx file
import {LoadingIcon} from 'shells/icon/svg/loading-icon';
import {WhatsAppIcon} from 'shells/icon/svg/whatsapp-icon';
import {IntegrationWidget} from 'shells/integration-widget/integration-widget';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {MessageContainer} from 'shells/message/message-container';
import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';
import {Body} from 'shells/typography/body';

type Props = {
    isConnected: boolean;
    connectIntegration: () => void;
    errorMessage?: string | null | undefined;
    hideErrorMessage: () => void;
    isLoadingConnection: boolean;
};

export function Connect(props: Props) {
    const banners = props.errorMessage && (
        <div className='mt-32'>
            <MessageContainer>
                <FlashBanner hasBorder={true} type='error' onHidden={props.hideErrorMessage}>
                    {props.errorMessage}
                </FlashBanner>
            </MessageContainer>
        </div>
    );

    return (
        <>
            {banners}
            <OnboardingBody title='Connect your account'>
                <div className='mt-16'>
                    {props.isLoadingConnection ? (
                        <div className='flex justify-center'>
                            <LoadingIcon size={64} />
                        </div>
                    ) : (
                        <StackLegacy spacing={4}>
                            <IntegrationWidget
                                status='initial'
                                account={null}
                                initialText='Connect to WhatsApp Business'
                                logo={
                                    <WhatsAppIcon
                                        size={24}
                                        alignCenter={true}
                                        wrapWithDiv={false}
                                        // @ts-expect-error
                                        color={colors.whatsappGreen}
                                    />
                                }
                                onConnectClick={() => {
                                    props.hideErrorMessage();
                                    props.connectIntegration();
                                }}
                                disabled={props.isConnected}
                                onDisconnectClick={() => {}}
                                fullWidthInitialButton={true}
                            />
                            <Body size='small' color='light'>
                                Via Facebook login for business
                            </Body>
                        </StackLegacy>
                    )}
                </div>
            </OnboardingBody>
        </>
    );
}
